import src from "IMAGE";
export default { src, width: 1880, height: 235, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mPI0RfIB+FYTb6EJG3+VF8lbv8wNd6IGA2+uCIjwTIAhN8H7zbZ7EoAAAAASUVORK5CYII="};
